import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Text,
  Button,
  Box,
  Flex,
  Center,
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import insightAreaNewsImage from "../../assets/event-news.png";

type NewsModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const NewsModal: React.FC<NewsModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "news",
  });
  const history = useHistory();

  const handleExploreEvents = () => {
    onClose();
    history.push("/insight-manager");
  };

  return (
    <Modal
      closeOnOverlayClick={false}
      size={"2xl"}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px) " />
      <ModalContent>
        <img
          src={insightAreaNewsImage}
          alt=""
          style={{
            borderRadius: "4px 4px 0 0",
          }}
        />
        <ModalBody py="40px" px="32px" color="black">
          <Flex flexDirection={"column"} gap="24px">
            <Center
              padding="4px 8px"
              bg="#DAD6F5"
              color="#130957"
              alignSelf="start"
              w="auto"
              borderRadius="4px"
              fontSize={"14px"}
              fontWeight="400"
              lineHeight="20px"
              h="24px"
            >
              {t("news")}
            </Center>
            <Text fontSize="24px" fontWeight="600" lineHeight="24px">
              {t("title")}
            </Text>
            <Box>
              <Text fontSize="16px" lineHeight="24px">
                {t("paragraph1")}
              </Text>
              <Text fontSize="16px" lineHeight="24px" mt="24px">
                {t("paragraph2Part1")}{" "}
                <Text as="strong" fontWeight="bold">
                  {t("paragraph2Bold1")}
                </Text>{" "}
                {t("paragraph2Part2")}
              </Text>
              <Text fontSize="16px" lineHeight="24px">
                {t("paragraph3Part1")}{" "}
                <Text as="strong" fontWeight="bold">
                  {t("paragraph3Bold")}
                </Text>
                {t("paragraph3Part2")}
              </Text>
            </Box>

            <Flex justifyContent={"space-between"} gap={"24px"}>
              <Button
                variant="outline"
                borderColor="#086AA9"
                color="#086AA9"
                bg="white"
                _hover={{ bg: "gray.50" }}
                onClick={handleExploreEvents}
                flex="1"
                h="40px"
                borderRadius="8px"
                fontWeight="400"
                fontSize="16px"
              >
                {t("exploreEvents")}
              </Button>
              <Button
                layerStyle="ocean"
                _hover={{ layerStyle: "ocean" }}
                onClick={() => onClose()}
                flex="1"
                h="40px"
                borderRadius="8px"
                fontWeight="400"
                fontSize="16px"
              >
                {t("gotIt")}
              </Button>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
